import { defineStore } from 'pinia'
import { ref } from 'vue'
import { searchCoverage } from '../../services/api/fhirAPI/coverage/coverage.js'
import { useSelectedPlan } from '../../stores/plans/selectedPlan.js'

const coverageSpan: number = 36

function xMonthsFromToday(months: number = coverageSpan) {
	const today = new Date()
	const dateMax = new Date(today)
	const newDate = new Date(dateMax.setMonth(dateMax.getMonth() - months))

	return newDate
}

function withinXMonths(val: string, months: number = coverageSpan) {
	const today = new Date()
	const dateMax = new Date(today)
	dateMax.setMonth(dateMax.getMonth() - months)
	const dateToCheck = new Date(val)
	return dateMax <= dateToCheck
}

export const useCoverage = defineStore(
	'coverage',
	() => {
		// ====---------------====
		// State
		// ====---------------====
		const planStore = useSelectedPlan()
		const coverage = ref<object>({})
		const loaded = ref(false)

		// ====---------------====
		// Getters
		// ====---------------====
		function getGroupId(memberId: string) {
			const arrClass = this.$state.coverage[memberId].class
			let code = ''
			arrClass.forEach((element) => {
				if (element.type.text.toLowerCase() == 'group') {
					code = element.type.id
				}
			})
			return code == '' ? false : code
		}

		// ====---------------====
		// Actions
		// ====---------------====
		function updateCoverage(memberId: string, payload: object) {
			coverage.value[memberId] = payload
			loaded.value = true
		}

		let loadCoverageRequest: Promise<string> | null = null
		const loadCoverageStore = async () => {
			if (loadCoverageRequest) {
				return loadCoverageRequest
			}
			loadCoverageRequest = new Promise(async (resolve, reject) => {
				try {
					let apiPlanId = planStore.isPolicyHolder ? planStore.contractId : planStore.memberId
					await searchCoverage(
						apiPlanId,
						`&versionId=2&_count=50&period=ge${xMonthsFromToday().getFullYear()}-01-01`
					)
						.then((res) => {
							if (res.total === 0) return
							res.loaded = true
							res.entry.forEach((covItem) => {
								const covItemType = covItem.resource.type.coding[0].code.toLowerCase()
								// check if active AND not already in store
								if (
									(covItem.resource.status === 'active' ||
										(covItem.resource.status === 'cancelled' &&
											withinXMonths(covItem.resource.period.end, coverageSpan))) &&
									!(coverage?.value ? covItem.resource.id in coverage?.value : false)
								) {
									// HIP
									if (covItemType === 'hip' && covItem.resource.id.includes(planStore.contractId)) {
										updateCoverage(covItem.resource.id, covItem.resource)
									}
									// Dental
									else if (
										covItemType === 'dental' &&
										covItemType === planStore.contractType.toLowerCase() &&
										covItem.resource.id.includes(planStore?.contractId)
									) {
										updateCoverage(covItem.resource.id, covItem.resource)
									}
									// Vision
									else if (
										covItemType === 'vision' &&
										covItemType === planStore.contractType.toLowerCase() &&
										covItem.resource.id.includes(planStore.contractId)
									) {
										updateCoverage(covItem.resource.id, covItem.resource)
									}
								}
							})
						})
						.catch((err) => {
							console.error(err)
						})

					resolve('')
				} catch (err) {
					reject(err)
				} finally {
					loadCoverageRequest = null
				}
			})
			return loadCoverageRequest
		}

		function $reset() {
			coverage.value = {}
			loaded.value = false
		}

		return {
			coverage,
			loaded,
			getGroupId,
			loadCoverageStore,
			$reset
		}
	},
	{
		persist: {
			storage: sessionStorage
		}
	}
)
